<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <v-overlay :value="visible" :absolute="false" opacity="1" scroll-strategy="block" class="overlay-mobile">
                <div class="main-container-mobile">
                    <!-- <img src="@/assets/img/top-left-bg.png" alt="Background" class="background-image-mobile-topleft" />
                    <img src="@/assets/img/top-right-bg.png" alt="Background"
                        class="background-image-mobile-topright" />
                    <img src="@/assets/img/bot-left-bg.png" alt="Background" class="background-image-mobile-botleft" />
                    <img src="@/assets/img/bot-right-bg.png" alt="Background"
                        class="background-image-mobile-botright" /> -->
                    <!-- <img src="@/assets/img/age-confirmation-bg.jpg" alt="Background" class="background-image-mobile" /> -->
                    <!-- <img src="@/assets/img/jameson-logo-age-confirm.jpg" alt="Background" class="background-image-mobile" /> -->
                    <div class="foreground-container-mobile">
                        <div class="first-block-mobile px-4">
                            <img src="@/assets/img/jameson-logo-age-confirm.png" alt="" class="jameson-logo-age-confirm-mobile mb-6" />
                        <div v-if="isLoadingForm" class="form-loading">
                            <v-progress-circular indeterminate size="64" color="#F1E4B2" />
                        </div>
                            <div v-else-if="hasError" class="error-container text-center py-10">
                                <h4 class="title-text mb-4" style="color: #CD122D;">Произошла ошибка при загрузке данных</h4>
                                <p class="mb-6">Не удалось получить ваши настройки. Пожалуйста, попробуйте обновить страницу позже.</p>                            
                            </div>
                            <div v-else>
                                <h4 class="title-text-mobile unsubscribe-title-mobile">
                                Выберите тип коммуникаций от которого Вы хотели бы отписаться:
                                </h4>
                            
                                <div class="checkboxes-container-mobile">
                                <v-checkbox
                                    v-model="form.doNotBulkEmail"
                                    label="Не получать массовые рекламные и информационные рассылки по E-mail"
                                    color="#F1E4B2"
                                    dark
                                    hide-details
                                    class="custom-checkbox mb-3"
                                ></v-checkbox>

                                <v-checkbox
                                v-model="form.doNotEmail"
                                    label="Не получать персонифицированные сообщения по E-mail"
                                    color="#F1E4B2"
                                    dark
                                    hide-details
                                    class="custom-checkbox mb-3"
                                ></v-checkbox>

                                <v-checkbox
                                v-model="form.doNotSendMm"
                                    label="Не получать любые коммуникации по всем каналам связи, включая SMS, телефон и E-mail."
                                    color="#F1E4B2"
                                    dark
                                    hide-details
                                    class="custom-checkbox mb-6"
                                    @change="handleAllCommChange"
                                ></v-checkbox>
                            </div>

                            <button @click="savePreferences" class="btn-confirm-mobile mt-4 mb-10" :disabled="isSaving">
                                {{ isSaving ? 'СОХРАНЕНИЕ...' : 'ОТПИСАТЬСЯ' }}
                            </button>
                                                   <div class="second-block-mobile">
                            <img src="@/assets/img/jameson-bottle-age-mobile.png" alt=""
                                class="jameson-age-confirm-mobile" />
                        </div>
                        </div>
                            </div>
                    </div>
                </div>
            </v-overlay>
        </div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
                <div class="main-container">
                    <img src="@/assets/img/top-left-bg.png" alt="Background" class="background-image-mobile-topleft" />
                    <img src="@/assets/img/top-right-bg.png" alt="Background"
                        class="background-image-mobile-topright" />
                    <img src="@/assets/img/bot-left-bg.png" alt="Background" class="background-image-mobile-botleft" />
                    <img src="@/assets/img/bot-right-bg.png" alt="Background"
                        class="background-image-mobile-botright" />
                    <!-- <img src="@/assets/img/age-confirmation-bg.jpg" alt="Background" class="background-image-mobile" /> -->
                    <!-- <img src="@/assets/img/jameson-logo-age-confirm.jpg" alt="Background" class="background-image-mobile" /> -->
                    <img src="@/assets/img/Group 7738.png" alt="Background" class="background-image" />

                    <div class="foreground-container">
                        <div class="logo-container">
                            <img src="@/assets/img/jameson-logo-age-confirm.png" alt="Jameson" class="logo" />
                        </div>
                        <div v-if="isLoadingForm" class="form-loading">
                            <v-progress-circular indeterminate size="64" color="#F1E4B2" />
                        </div>
                        <div v-else-if="hasError" class="error-container text-center py-10">
                                <h4 class="title-text mb-4" style="color: #CD122D;">Произошла ошибка при загрузке данных</h4>
                                <p class="mb-6">Не удалось получить ваши настройки. Пожалуйста, попробуйте обновить страницу позже.</p>                            </div>
                        <div v-else class="second-container">
                            <div class="first-block">

                            <div class="first-block text-left">
                                <h4 class="title-text unsubscribe-title">
                                    Выберите тип коммуникаций от которого Вы хотели бы отписаться:
                                </h4>
                                
                                <div class="checkboxes-container">
                                    <v-checkbox
                                       v-model="form.doNotBulkEmail"
                                        label="Не получать массовые рекламные и информационные рассылки по E-mail"
                                        color="#F1E4B2"
                                        dark
                                        hide-details
                                        class="custom-checkbox mb-2"
                                    ></v-checkbox>

                                    <v-checkbox
                                        v-model="form.doNotEmail"
                                        label="Не получать персонифицированные сообщения по E-mail"
                                        color="#F1E4B2"
                                        dark
                                        hide-details
                                        class="custom-checkbox mb-2"
                                    ></v-checkbox>

                                    <v-checkbox
                                        v-model="form.doNotSendMm"
                                        label="Не получать любые коммуникации по всем каналам связи, включая SMS, телефон и E-mail."
                                        color="#F1E4B2"
                                        dark
                                        hide-details
                                        class="custom-checkbox mb-6"
                                    
                                    ></v-checkbox>
                                </div>

                                <button  @click="savePreferences" class="btn-confirm mt-10 mb-10" :disabled="isSaving" >
                                    {{ isSaving ? 'СОХРАНЕНИЕ...' : 'ОТПИСАТЬСЯ' }}
                                </button>
                            </div>
                        </div>
                        <div class="second-block">
                            <img src="@/assets/img/jameson-age-confirm.png" alt="" class="jameson-age-confirm" />
                        </div>
                        </div>
                    </div>
                </div>
        </div>
        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    Закрыть
                </div>
            </template>
        </v-snackbar>
    </div>
</template>

<style scoped>
.second-block {
    display: flex;
    justify-content: center; /* Центрируем картинку по горизонтали */
    align-items: center;     /* Центрируем по вертикали */
    flex: 1;                 /* Заставляет блок занимать оставшееся свободное место */
    padding: 20px;           /* Небольшой отступ, чтобы картинка не прилипала к краям */
}

/* Сама картинка */
.jameson-age-confirm {
    max-width: 100%;       /* Картинка никогда не будет шире своего родителя */
    height: auto;          /* Высота подстраивается автоматически, сохраняя пропорции */
    max-height: 80vh;      /* Картинка не будет выше, чем 80% от высоты экрана */
    object-fit: contain;   /* Гарантирует, что бутылки не обрежутся и не сплюснутся */
}
.second-block-mobile {
    display: flex;
    justify-content: center;
}
.unsubscribe-title-mobile {
    margin-top: 0;
    margin-bottom: 20px;
    font-size: 20px; /* Делаем шрифт чуть меньше, чем на десктопе */
    line-height: 1.3;
    text-align: center; /* На мобилках заголовок часто лучше смотрится по центру */
    white-space: normal; /* Убираем жесткие переносы, если они были */
}

/* Контейнер чекбоксов на мобилке */
.checkboxes-container-mobile {
    display: flex;
    flex-direction: column;
    text-align: left; /* Текст чекбоксов обязательно по левому краю, иначе тяжело читать */
    width: 100%;
    max-width: 400px; /* Ограничиваем ширину на планшетах/больших телефонах */
    margin: 0 auto; /* Центрируем сам блок */
}
.first-block.text-left {
    text-align: left;
    max-width: 600px; /* Ограничиваем ширину, чтобы текст не растягивался на весь экран */
}

/* Стили для нового заголовка */
.unsubscribe-title {
    margin-top: 0;
    margin-bottom: 30px;
    font-size: 24px;
    line-height: 1.3;
    text-align: left; /* Перебиваем старый text-align: center, если он остался */
}

/* Обертка для чекбоксов */
.checkboxes-container {
    display: flex;
    flex-direction: column;
    gap: 12px; /* Расстояние между чекбоксами */
}

/* Кастомный стиль для текста чекбоксов (чтобы был шрифт нужного цвета и размера) */
::v-deep .custom-checkbox .v-label {
    border-color: #F1E4B2 !important;
    color: #F1E4B2 !important;
    font-family: var(--font-family); /* Или "jj2bold" */
    font-size: 16px;
    opacity: 0.9;
    align-items: flex-start; /* Чтобы многострочный текст выравнивался по верху чекбокса */
    padding-top: 2px;
    
}
::v-deep .custom-checkbox .v-input--selection-controls__ripple {
  color: #F1E4B2 !important;
}
::v-deep .custom-checkbox .v-icon {
  color: #F1E4B2 !important;
}
/* Стили для новой кнопки отписки */
.btn-unsubscribe {
    border-radius: 4px; /* На вашем макете углы острые/квадратные */
    padding: 12px 30px;
    color: #007749;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 18px;
    background: #F1E4B2;
    border: none;
    cursor: pointer;
    text-transform: uppercase;
    letter-spacing: 1px;
    transition: all 0.3s ease;
}

.btn-unsubscribe:hover {
    background: #fff3c7;
}

.btn-unsubscribe:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}
::v-deep .v-overlay__scrim {
    opacity: 1;
    /* background-color: #007749 !important;
    border-color: #007749 !important; */
    background-image: url('../assets/img/social-lead-first-bg.jpg');
    background-size: cover;
    background-position: center;
}



.overlay-mobile ::v-deep .v-overlay__content {
 position: relative;
  max-height: 100vh; /* ограничиваем высоту окна */
  overflow-y: auto;  /* включаем скролл внутри */
}

.background-image-mobile-botright {
    position: absolute;
    bottom: -1px;
    right: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-botleft {
    position: absolute;
    bottom: -1px;
    left: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;

}

.background-image-mobile-topright {
    position: absolute;
    top: -1px;
    right: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

.background-image-mobile-topleft {
    position: absolute;
    top: -1px;
    left: 0;
    height: auto;
    /* width: 100%; */
    object-fit: cover;
    z-index: 1;
}

/* .background-image-mobile {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    z-index: 1;
} */

.foreground-container-mobile {
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 1000;
    color: #000;
    font-size: 24px;
    /* gap: 48px; */
    height: 100vh;
    justify-content: flex-start;

}

.btn-confirm,
.btn-confirm-mobile {
    /* border-radius: 10px; */
    padding: 11px 42px;
    height: 59px;
    color: #007749;
    font-family: "jj2bold";
    font-weight: 400;
    font-size: 20px;
    background: #f1e4b2;
    cursor: pointer;
    /* box-shadow: 0 4px 0 #04581d; */
    /* легкая тень для объёма */

    /* медленный возврат */
    transition: all 0.4s ease;
}

/* При наведении */
.btn-confirm:hover,
.btn-confirm-mobile:hover {
    background: #f5f5f5;
    /* лёгкое затемнение белого */
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #bcbcbc;

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-confirm:active,
.btn-confirm-mobile:active {
    background: #e6e6e6;
    /* чуть темнее для нажатия */
    transform: translateY(2px);
    box-shadow: 0 2px 0 #9e9e9e;
    transition: all 0.1s ease-in;
}

.title-text-mobile {
    margin-bottom: 0px;
    font-family: "jj2bold";
    color: #F1E4B2;
    font-size: 24px;
    line-height: 117%;
    letter-spacing: 0.04em;
    text-align: center;

    font-weight: 700;
    margin-top: 33px;
}

.title-text-mobile pre {
    margin-bottom: 0px;
    font-family: "jj2bold";
    color: #F1E4B2;
    font-size: 24px;
    line-height: 117%;
    letter-spacing: 0.04em;
    text-align: center;

    font-weight: 700;
}

.first-block-mobile {
    padding-top: 50px;
    text-align: center;
}

.main-container-mobile {
    /* background-image: url('../assets/img/social-lead-first-bg.jpg'); */
    background-size: cover;
    background-position: center;
    position: relative;
    min-height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    /* overflow-y: auto; */
    padding-top: 50px;
}

.date-input {
    width: 115px;
    height: 55px;
    border: 2px solid #F1E4B2;
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: HelveticaNeueCyr;
    font-weight: 700;
    font-size: 20px;
    color: #F1E4B2;
    outline: none;
}

.date-input::placeholder {
    color: white;
    opacity: 1;
}

.date-input:focus {
    border-color: red;
}

.date-input-mobile::placeholder {
    color: #F1E4B2;
    opacity: 1;
}

.date-input-mobile:focus {
    border-color: red;
}

.date-input-container-mobile {
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-bottom: 20px;
    justify-content: center;
    margin-top: 33px;
    text-align: center;
    align-items: center;
}

.date-input-mobile {
    width: 325px;
    height: 55px;
    border: 2px solid #F1E4B2;
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: HelveticaNeueCyr;
    font-weight: 700;
    font-size: 20px;
    color: #F1E4B2;
    outline: none;
}

.jameson-logo-age-confirm-mobile {
    width: 285.48px;
    height: 68.16px;
}

/* Убираем стрелочки */
.date-input::-webkit-inner-spin-button,
.date-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.date-input {
    -moz-appearance: textfield;
    /* Для Firefox */
}

.date-input-container {
    display: flex;
    gap: 10px;
    /* Расстояние между полями */
    margin-bottom: 20px;
    justify-content: center;
    margin-top: 33px;
}

.date-input {
    width: 115px;
    height: 55px;
    border: 2px solid #f1e4b2;
    border-radius: 10px;
    background-color: transparent;
    text-align: center;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 20px;
    color: #f1e4b2;
    outline: none;
}

.date-input::placeholder {
    color: #f1e4b2;
    opacity: 1;
}

.date-input:focus {
    border-color: red;
}

.btn-confirm {
    /* border-radius: 10px; */
    padding: 11px 42px;
    width: 231px;
    height: 59px;
    color: #f2e4b5;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 20px;
    color: #007749;
    background: #f1e4b2;
}

.first-block {
    text-align: center;
}

.title-text {
    margin-bottom: 0px;
    font-family: var(--font-family);
    font-weight: 700;
    font-size: 30px;
    color: #f1e4b2;
    margin-top: 66px;
}


.main-container {
    position: relative;
    /* Родительский контейнер для абсолютного позиционирования */
    height: 100vh;
    /* Высота на весь экран */
    width: 100vw;
    /* Ширина на весь экран */
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    /* Убираем прокрутку */
}

.background-image {
    position: absolute;
    /* Абсолютное позиционирование */
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    object-fit: cover;
    /* Пропорциональное сжатие */
    z-index: 1;
    /* Отправляем изображение на задний план */
}

.foreground-container {
    display: flex;
    align-items: center;
    flex-direction: column;
    position: relative;
    /* Текст остается поверх */
    z-index: 1000;
    /* Устанавливаем текст выше изображения */
    color: #000;
    /* Цвет текста */
    font-size: 24px;
    gap: 48px;
}
.second-container {
    padding: 20px;
        display: flex;
    align-items: center;
    position: relative;
    /* Текст остается поверх */
    z-index: 1000;
    /* Устанавливаем текст выше изображения */
    color: #000;
    /* Цвет текста */
    font-size: 24px;
    gap: 48px;
}
.snackbar-btn {
    color: var(--Red, #eb5757);
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}

/* @media (orientation: landscape) {
    .foreground-container-mobile {
        height: auto;
    }
} */.error-container {
    background: rgba(255, 255, 255, 0.05); /* Легкий фон */
    border: 1px solid #F1E4B2; /* Золотистая рамка в стиле бренда */
    border-radius: 8px;
    padding: 40px 20px;
    max-width: 500px;
    margin: 0 auto;
    font-family: var(--font-family);
    color: #F1E4B2;
}

.error-container h4 {
    color: #F1E4B2; /* Цвет заголовка */
    margin-top: 0px;
   font-family: var(--font-family) /* Если есть кастомный шрифт */
}
</style>

<script>
import { mapActions } from "vuex";

export default {


    name: "UnsubscribeView",
    data() {
        return {
            isMobile: window.innerWidth < 1264,
            day: "",
            month: "",
            year: "",
            snackbar: false,
            message: "",
            visible: true,
            isLoadingForm: true,
            isSaving: false,
            hasError: false,
            form: {
                doNotSendMm: false,
                doNotEmail: false,
                doNotBulkEmail: false
            }
        };
    },
    methods: {


        ...mapActions(['saveUserAge']),


        handleResize() {
            this.isMobile = window.innerWidth < 1264;
        },
        validateDay() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 2 символов
            this.day = this.day.replace(/\D/g, "").slice(0, 2);

            // Проверяем, что значение не превышает 31
            if (this.day > 31) {
                this.day = ""; // Очищаем поле, если значение некорректно
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный день (01-31).";
            }
        },
        validateMonth() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 2 символов
            this.month = this.month.replace(/\D/g, "").slice(0, 2);

            // Проверяем, что значение не превышает 12
            if (this.month > 12) {
                this.month = ""; // Очищаем поле, если значение некорректно
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный месяц (01-12).";
            }
        },
        validateYear() {
            // Убираем все символы, кроме цифр, и ограничиваем длину до 4 символов
            this.year = this.year.replace(/\D/g, "").slice(0, 4);
        },
        async savePreferences() {
            this.isSaving = true;
            
            try {
                // 1-й аргумент: URL
                // 2-й аргумент: сами данные (библиотека сама превратит их в JSON и добавит заголовки)
                await this.$http.put(`/api/lead/${this.leadId}/communication`, this.form);

                // Важный момент: если вы используете Axios, свойства `response.ok` не существует 
                // (оно есть только у встроенного браузерного fetch). 
                // Но Axios устроен так: если сервер ответит ошибкой (400, 500), 
                // код сразу прыгнет в блок catch. 
                // Поэтому, если выполнение дошло до этой строчки — запрос уже 100% успешен!
                
                this.message = "Ваши настройки успешно сохранены";
                this.snackbar = true;

            } catch (e) {
                console.error("Ошибка сохранения:", e);
                this.message = "Произошла ошибка при сохранении.";
                this.snackbar = true; // Можно тоже показать снэкбар с ошибкой
            } finally {
                this.isSaving = false;
            }
  },
        confirmRegistration() {
            let isValid = true;

            // Проверяем корректность дня
            if (this.day.length !== 2 || this.day > 31 || this.day < 1) {
                this.day = ""; // Очищаем поле
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный день (01-31).";
                isValid = false;
            }

            // Проверяем корректность месяца
            if (this.month.length !== 2 || this.month > 12 || this.month < 1) {
                this.month = ""; // Очищаем поле
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный месяц (01-12).";
                isValid = false;
            }

            // Проверяем корректность года
            if (this.year.length !== 4 || this.year < 1900 || this.year > new Date().getFullYear()) {
                this.year = ""; // Очищаем поле
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректный год рождения.";
                isValid = false;
            }

            // Если есть некорректные поля, прекращаем выполнение
            if (!isValid) {
                return;
            }

            // Проверяем, что дата корректна
            const today = new Date();
            const birthDate = new Date(this.year, this.month - 1, this.day);

            if (
                birthDate.getDate() != this.day ||
                birthDate.getMonth() + 1 != this.month ||
                birthDate.getFullYear() != this.year
            ) {
                this.snackbar = true;
                this.message = "Пожалуйста, введите корректную дату.";
                return;
            }

            // Проверяем возраст
            const age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();
            const dayDiff = today.getDate() - birthDate.getDate();

            if (age > 21 || (age === 21 && (monthDiff > 0 || (monthDiff === 0 && dayDiff >= 0)))) {
                console.log(`Дата рождения: ${this.day}.${this.month}.${this.year}`);
                const userAge = `${this.year}-${this.month}-${this.day}`; // строка вида "дд.мм.гггг"


                // console.log("Итоговые данные:", userAge);
                // this.snackbar = true;

                // this.message = "Добро пожаловать!";
                this.saveUserAge(userAge);
                this.visible = false;
                document.body.style.overflow = "";
                document.body.style.height = "";// Сохраняем в Vuex
                // this.$router.push('/jameson'); // Переход на следующую страницу
            } else {
                this.snackbar = true;
                this.message = "Для дальнейшего входа нужно достичь 21 года.";
                return;
            }

            // Собираем данные в переменную userAge

        },


    },
    beforeDestroy() {
        document.body.style.overflow = ""
        document.body.style.height = ""
        window.removeEventListener('resize', this.handleResize);
    },
    async mounted() {
       try {
        const response = await this.$http.get(`/api/lead/${this.leadId}/communication`);
        
        // В Axios данные лежат в свойстве .data
        const data = response.data; 
        
        this.form = {
            doNotSendMm: !!data.doNotSendMm,
            doNotEmail: !!data.doNotEmail,
            doNotBulkEmail: !!data.doNotBulkEmail
        };
        
    } catch (e) {
        console.error('Ошибка:', e);
        this.error = true;
        this.hasError = true;
        if (e.response && e.response.status === 404) {
        this.errorMessage = "Пользователь не найден или ссылка устарела.";
        } else {
            this.errorMessage = "Произошла техническая ошибка. Попробуйте позже.";
        }
    } finally {
        this.isLoadingForm = false;
    }
        document.body.style.overflow = "hidden"
        document.body.style.height = "100vh"
        window.addEventListener('resize', this.handleResize);

    },
    computed: {
        leadId() {
      return this.$route.params.leadId;
    }
        // bgStyle() {
        //     return {
        //         backgroundImage: `url(${require('@/assets/img/age-confirmation-bg.png')})`,
        //         backgroundSize: 'contain',
        //         backgroundRepeat: 'no-repeat',
        //         backgroundPosition: 'center',
        //         width: '100vw', // Полная ширина экрана
        //         height: '100vh',
        //     };
        // }
    },

}

</script>